export const GET_MAILINGS = 'GET_MAILINGS'
export const GET_MAILING = 'GET_MAILING'
export const CREATE_MAILING = 'CREATE_MAILING'
export const EDIT_MAILING = 'EDIT_MAILING'
export const DELETE_MAILING = 'DELETE_MAILING'
